import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { toast } from "sonner";

export default function CopyLog() {
  const [rows, setRows] = useState([]);
  const [targets, setTargets] = useState([]);
  const [f, setF] = useState({ start: "", end: "", target: "", q: "" });
  const [denied, setDenied] = useState(false);
  const load = () => api.get("/customers-copy/log", { params: f, silent: true }).then((r) => setRows(r.data)).catch((e) => { if (e.response?.status === 403) setDenied(true); else toast.error(e.response?.data?.detail || "HATA"); });
  useEffect(() => { api.get("/customers-copy/targets", { silent: true }).then((r) => setTargets(r.data)).catch(() => setDenied(true)); }, []);
  useEffect(() => { load(); }, [f]); // eslint-disable-line react-hooks/exhaustive-deps
  if (denied) return <div data-testid="copy-log-denied" className="rounded border border-slate-700 p-4 text-sm text-slate-400">AKTARMA GEÇMİŞİ SADECE ANA DEPO İÇİNDİR.</div>;
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  return (
    <div data-testid="copy-log" className="space-y-2">
      <div className="flex flex-wrap items-center gap-2">
        <Input data-testid="copy-log-start" type="date" value={f.start} onChange={set("start")} className="h-8 w-40 border-slate-700 bg-slate-900" />
        <Input data-testid="copy-log-end" type="date" value={f.end} onChange={set("end")} className="h-8 w-40 border-slate-700 bg-slate-900" />
        <select data-testid="copy-log-target" value={f.target} onChange={set("target")} className="h-8 rounded border border-slate-700 bg-slate-900 px-2 text-sm text-slate-100">
          <option value="">TÜM FİRMALAR</option>
          {targets.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
        <Input data-testid="copy-log-search" placeholder="MÜŞTERİ ARA" value={f.q} onChange={set("q")} className="h-8 w-48 border-slate-700 bg-slate-900" />
        <Button data-testid="copy-log-clear" variant="outline" onClick={() => setF({ start: "", end: "", target: "", q: "" })} className="h-8 border-slate-700 bg-slate-800 text-xs">TEMİZLE</Button>
        <span data-testid="copy-log-count" className="text-xs text-slate-400">{rows.length} KAYIT</span>
      </div>
      <div className="max-h-[60vh] overflow-auto rounded border border-slate-800">
        <table className="w-full text-xs">
          <thead className="sticky top-0 bg-slate-800 text-left text-slate-300">
            <tr><th className="px-2 py-1.5">TARİH</th><th className="px-2">MÜŞTERİ</th><th className="px-2">İL</th><th className="px-2">HEDEF FİRMA</th><th className="px-2">AKTARAN</th><th className="px-2">DURUM</th></tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`copy-log-row-${r.id}`} className="border-t border-slate-800 text-slate-200">
                <td className="px-2 py-1">{new Date(r.at).toLocaleString("tr-TR")}</td><td className="px-2 font-semibold">{r.firma}</td><td className="px-2">{r.il}</td>
                <td className="px-2">{r.target_name}</td><td className="px-2">{r.by}</td>
                <td className={`px-2 font-bold ${r.durum === "EKLENDİ" ? "text-emerald-400" : "text-amber-400"}`}>{r.durum}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={6} className="px-2 py-6 text-center text-slate-500">KAYIT YOK</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
